import {Directive, HostListener} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
    selector: '[afDigitsLatinUppercase]',
    standalone: false
})
export class DigitsLatinUppercaseDirective {
    constructor(private control: NgControl) {
    }

    @HostListener('input', ['$event'])
    onInput(event: Event): void {
        const input = event.target as HTMLInputElement;
        let value = input.value.toUpperCase();
        value = value.replace(/[^A-Z0-9]/g, '');
        this.control.control?.setValue(value, {emitEvent: false});
        input.value = value;
    }
}
